import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss']
})
export class IconComponent implements OnInit {
    @Input() className: string;
    @Input() iconId: number;
    @Input() iconName: string;
    @Input() iconSize: number = 24;
    @Input() hide: boolean = false;
    private template: string = '/assets/img/';
    templateUrl: string = ''

    ngOnInit() {
        if (this.iconId) {
            this.templateUrl = this.template + 'id_icons/' + this.iconId + '.svg';
            return;
        }
        if (this.iconName) {
            const iconFileName = this.getTemplate(this.iconName);
            if (iconFileName) {
                this.templateUrl = this.template + iconFileName;
            }
        }
    }

    private getTemplate(iconName: string): string {
        switch (iconName) {
            case '17':
                return 'id_icons/17.svg';
            case 'alarm':
                return 'icons/alarm.svg';
            case 'constant-temp':
                return 'zone_icons/constant_temp.svg';
            case 'DHW':
                return 'zone_icons/light/DHW.svg';
            case 'menu-fitters':
                return 'zone_icons/menu_fitters.svg';
            case 'opentherm':
                return 'zone_icons/light/opentherm-light.svg';
            case 'power':
                return 'zone_icons/power_white.svg';
            case 'relay':
                return 'zone_icons/relay.svg';
            case 'schedule':
                return 'zone_icons/schedule.svg';
            case 'settings':
                return 'zone_icons/settings.svg';
            case 'sun-cloud':
                return 'zone_icons/sun_cloud_light.svg';
            case 'time-limit':
                return 'zone_icons/time_limit.svg';
            case 'underfloor':
                return 'zone_icons/underfloor.svg';
            case 'valve':
                return 'zone_icons/light/valve.svg';
            case 'window_sun':
                return 'zone_icons/window_sun.svg';
            default:
                return '';
        }
    }
}
